var Form = function (options) {
	this.options = {
		$el: false,
		baseClass: 'el-Form',
	};

	$.extend(true, this.options, options);
};

Form.prototype.init = function () {
	// Webflow class bridging is handled server-side via Formie's themeConfig
	// in templates/_includes/formie-theme.twig — no DOM post-processing needed.
	//
	// Apply Now functionality is handled by the Modal trigger system
	// (see Modal.js initTriggers()).
};

export default Form;
